import React from 'react';
import { useTranslation } from 'react-i18next';
import { SITE_URLS } from '@constants';
import { useSEOMetatags } from '@hooks/useSEOMetatags';
import { FiltersProvider } from '@context';
import { ManageServices } from '@components/templates/myAccount/manageServices';

export function ManageServicesPage() {
    const { t } = useTranslation();

    const translations = {
        title: t('manage-services-component.metatags.title'),
        description: t('manage-services-component.metatags.description'),
    };

    useSEOMetatags({
        title: translations.title,
        description: translations.description,
        url: SITE_URLS.myServices,
        index: false,
    });

    return (
        <FiltersProvider>
            <ManageServices />
        </FiltersProvider>
    );
}
